/* 🤖 this file was generated by svg-to-ts */
export const matIconTurnSlightLeft: {
  name: 'turn-slight-left';
  data: string;
} = {
  name: 'turn-slight-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11.66 6V4H6v5.66h2V7.41l5 5V20h2v-7.58c0-.53-.21-1.04-.59-1.41l-5-5h2.25z"/></svg>`
};
